"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _PluggableElementBase2 = _interopRequireDefault(require("./PluggableElementBase"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ConnectionType = /*#__PURE__*/function (_PluggableElementBase) {
  (0, _inherits2.default)(ConnectionType, _PluggableElementBase);

  var _super = _createSuper(ConnectionType);

  function ConnectionType(stuff) {
    var _this;

    (0, _classCallCheck2.default)(this, ConnectionType);
    _this = _super.call(this, stuff);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "stateModel", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "configSchema", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "displayName", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "description", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "url", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "configEditorComponent", void 0);
    _this.stateModel = stuff.stateModel;
    _this.configSchema = stuff.configSchema;
    _this.displayName = stuff.displayName;
    _this.description = stuff.description;
    _this.url = stuff.url;
    _this.configEditorComponent = stuff.configEditorComponent;

    if (!_this.stateModel) {
      throw new Error("no stateModel defined for connection ".concat(_this.name));
    }

    if (!_this.configSchema) {
      throw new Error("no configSchema defined for connection ".concat(_this.name));
    }

    return _this;
  }

  return ConnectionType;
}(_PluggableElementBase2.default);

exports.default = ConnectionType;